import { gsap } from 'gsap'

import { Observer } from 'gsap/Observer'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

// Dragging disabled; add Draggable/InertiaPlugin back in if drag-to-spin is needed again.
// import { Draggable } from 'gsap/Draggable'
// import { InertiaPlugin } from 'gsap/InertiaPlugin'

gsap.registerPlugin(Observer, ScrollTrigger)

function init3dImageCarousel() {
    let radius
    let observerInstance
    let spin
    let intro
    let lastWidth = window.innerWidth

    const wrap = document.querySelector('[data-3d-carousel-wrap]')
    if (!wrap) return

    // Define the radius of your cylinder here
    const calcRadius = () => {
        //
        if (window.innerWidth > 1024) {
            radius = window.innerWidth * 0.4
        } else {
            radius = window.innerWidth * 0.5
        }
        // radius = 600
    }

    // Destroy function to reset everything on resize
    const destroy = () => {
        observerInstance && observerInstance.kill()
        spin && spin.kill()
        intro && intro.kill()
        // ScrollTrigger.getAll().forEach((st) => st.kill())
        const panels = wrap.querySelectorAll('[data-3d-carousel-panel]')
        gsap.set(panels, { clearProps: 'transform' })
    }

    // Create function that sets the spin, drag, and rotation
    const create = () => {
        calcRadius()

        const panels = wrap.querySelectorAll('[data-3d-carousel-panel]')
        const content = wrap.querySelectorAll('[data-3d-carousel-content]')

        // panels op cilinder zetten
        panels.forEach((p) => {
            p.style.transformOrigin = `50% 50% ${-radius}px`
        })

        // oneindige rotatie van de panels ROND het middelpunt
        spin = gsap.fromTo(
            panels,
            {
                // +180° zodat de voorkant naar het middelpunt wijst
                rotationY: (i) => (i * 360) / panels.length + 180
            },
            {
                rotationY: '-=360', // laat de hele ring draaien
                duration: 15,
                ease: 'none',
                repeat: -1
            }
        )

        // cheeky workaround to create some 'buffer' when scrolling back up
        spin.progress(1000)

        /*
         * Drag-to-spin behavior disabled. Uncomment this block and the Draggable/InertiaPlugin
         * import + registration above to allow mouse/touch dragging again.
         */
        // const proxy = document.createElement('div')
        // const wrapProgress = gsap.utils.wrap(0, 1)
        // const dragDistance = window.innerWidth * 3 // Control the snapiness on drag
        // let startProg
        //
        // draggableInstance = Draggable.create(proxy, {
        //     trigger: wrap,
        //     type: 'x',
        //     inertia: true,
        //     allowNativeTouchScrolling: true,
        //     onPress() {
        //         // Subtle feedback on touch/mousedown of the wrap
        //         gsap.to(content, {
        //             clipPath: 'inset(5%)',
        //             duration: 0.3,
        //             ease: 'power4.out',
        //             overwrite: 'auto'
        //         })
        //         // Stop automatic spinning to prepare for drag
        //         gsap.killTweensOf(spin)
        //         spin.timeScale(0)
        //         startProg = spin.progress()
        //     },
        //     onDrag() {
        //         const p = startProg + (this.startX - this.x) / dragDistance
        //         spin.progress(wrapProgress(p))
        //     },
        //     onThrowUpdate() {
        //         const p = startProg + (this.startX - this.x) / dragDistance
        //         spin.progress(wrapProgress(p))
        //     },
        //     onRelease() {
        //         if (!this.tween || !this.tween.isActive()) {
        //             gsap.to(spin, { timeScale: 1, duration: 0.1 })
        //         }
        //         gsap.to(content, {
        //             clipPath: 'inset(0%)',
        //             duration: 0.5,
        //             ease: 'power4.out',
        //             overwrite: 'auto'
        //         })
        //     },
        //     onThrowComplete() {
        //         gsap.to(spin, { timeScale: 1, duration: 0.1 })
        //     }
        // })[0]

        // Scroll-into-view animation
        intro = gsap.timeline({
            scrollTrigger: {
                trigger: wrap,
                start: 'top 80%',
                end: 'bottom top',
                scrub: false,
                toggleActions: 'play resume play play'
            },
            defaults: { ease: 'expo.inOut' }
        })
        intro
            .fromTo(spin, { timeScale: 15 }, { timeScale: 1, duration: 2 })
            //.fromTo(wrap, { scale: 0.5, rotation: 12 }, { scale: 1, rotation: 5, duration: 1.2 }, '<')
            .fromTo(
                content,
                { autoAlpha: 0 },
                { autoAlpha: 1, stagger: { amount: 0.8, from: 'random' } },
                '<'
            )

        // While-scrolling feedback
        observerInstance = Observer.create({
            target: window,
            type: 'wheel,scroll,touch',
            onChangeY: (self) => {
                // Boost spin speed only when scrolling downward; never reverse direction.
                const boost = gsap.utils.clamp(0, 6, self.velocityY * 0.005)
                const targetSpeed = 1 + boost
                spin.timeScale(targetSpeed)

                gsap.fromTo(
                    { value: targetSpeed },
                    { value: targetSpeed },
                    {
                        value: 1,
                        duration: 1.2,
                        onUpdate() {
                            spin.timeScale(this.targets()[0].value)
                        }
                    }
                )
            }
        })
    }

    // First create on function call
    create()

    // Debounce function to use on resize events
    const debounce = (fn, ms) => {
        let t
        return () => {
            clearTimeout(t)
            t = setTimeout(fn, ms)
        }
    }

    // Whenever window resizes, first destroy, then re-init it all
    window.addEventListener(
        'resize',
        debounce(() => {
            const newWidth = window.innerWidth
            if (newWidth !== lastWidth) {
                lastWidth = newWidth
                destroy()
                create()
                ScrollTrigger.refresh()
            }
        }, 200)
    )
}

// Initialize 3D Image Carousel

document.addEventListener('DOMContentLoaded', () => {
    gsap.registerPlugin(Observer, ScrollTrigger)
    init3dImageCarousel()
})
